export type CreditPartner = {
  slug: 'juliusbranding' | 'syne';
  name: string;
  description?: string;
  // Wordmark shown in place of the typed name as the page heading
  logo?: string;
  statement: string;
  roles: string[];
  note?: string;
  link: { label: string; href: string };
};

// Shared by the Imprint credits and the /juliusbranding and /syne subpages
export const creditPartners: CreditPartner[] = [
  {
    slug: 'juliusbranding',
    name: 'Julius Branding',
    statement:
      'Brand design, strategy, concept and development of the Superluxury brand and the superluxury.io website.',
    roles: ['Brand design', 'Strategy', 'Concept', 'Website design', 'Development'],
    note: 'Designed in Germany — AI first.',
    link: { label: 'juliusbranding.com', href: 'https://juliusbranding.com' },
  },
  {
    slug: 'syne',
    name: 'Syne',
    description: 'Design, artificial intelligence and technology agency.',
    logo: 'https://cdn.magicpatterns.com/uploads/4SYwDAP2caQ2anJVrrryJB/Vector.svg',
    statement:
      'Brand design, strategy, concept and development of the Superluxury brand and the superluxury.io website.',
    roles: ['Brand design', 'Strategy', 'Concept', 'Website design', 'Development'],
    link: { label: 'syne.digital', href: 'https://syne.digital' },
  },
];
